import { render } from "./PaymentTypeSelect.vue?vue&type=template&id=116b5426"
import script from "./PaymentTypeSelect.vue?vue&type=script&lang=js"
export * from "./PaymentTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__